module.exports = __webpack_public_path__ + "img/room-icon.9ceb3400.png";